import { FC } from 'react';

import { Callbacks, usePostMessageListener } from '../../hooks/post-message-listener';

const MX_RECOMMENDED_MIN_WIDTH = 320;

const DEFAULTS = {
  height: '650',
  width: '100%',
  title: 'Bank Connection Widget',
};

type Props = Callbacks & {
  widgetUrl: string;
  title?: string;
  height?: HTMLIFrameElement['height'];
  width?: HTMLIFrameElement['width'];
};

const BankConnection: FC<Props> = ({
  widgetUrl,
  onBankAccountVerificationSuccess,
  height = DEFAULTS.height,
  width = DEFAULTS.width,
  title = DEFAULTS.title,
}: Props) => {
  usePostMessageListener({
    onBankAccountVerificationSuccess,
  });
  return (
    <iframe
      name="bankConnectionWidget"
      height={height}
      src={widgetUrl}
      title={title}
      width={width}
      style={{ border: 0, minWidth: MX_RECOMMENDED_MIN_WIDTH }}
    />
  );
};

export { BankConnection };
